import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { RippleWaveAnimation } from '../blasts/RippleWave';

registerCollisionAnimation('RIPPLE', (ctx, e, config, progress) => {
  RippleWaveAnimation(ctx, e as any, config, progress);
});
